<template>
  <div>
    <div class="carousel">
      <van-swipe @change="onChange" :show-indicators="false">
        <van-swipe-item
          v-for="(image, index) in goodsInfo.imagePath"
          :key="index"
        >
          <!--          <img v-lazy="image"  class="imgPic"/>-->
          <!-- <img :src="baseImg + image"
               alt=""
               class="imgPic" :style="{height:windowWidth} "> -->
          <img :src="baseImg + image" alt="" class="imgPic" />
        </van-swipe-item>
      </van-swipe>
      <div class="subscript">
        <span class="currentIndex">{{ currentIndex + 1 }}</span
        >/<span class="allSum">{{ goodsInfo.imagePath.length }}</span>
      </div>
    </div>

    <div class="padBox">
      <div class="proPrice">
        <div class="value">
          <span class="unit">￥</span><span>{{ integerPrice }}</span
          ><span class="decimals">.{{ decimalsPrice }}</span>
        </div>
        <div>销售:{{ goodsInfo.salesVolume }}件</div>
      </div>
      <div class="proName">{{ goodsInfo.name }}</div>
    </div>
    <div class="occupie"></div>
    <div class="shopName">
      <img
        v-if="goodsInfo.sellerLogo"
        :src="baseImg + goodsInfo.sellerLogo"
        class="shopLogo"
      />
      <img
        v-else
        src="@/assets/img/iv_placeholder_Center@2x.png"
        class="shopLogo"
      />
      <span>{{ goodsInfo.sellerName }}</span>
    </div>
    <div class="description" v-html="goodsInfo.description"></div>
    <!--    <img src="@/assets/img/proDetailPic.png" alt="" class="proDetailPic">-->
    <div class="f-box" ref="buyBody">
      <div v-if="k800 == 0" class="shop-btn" @click="linkBuyCart">
        <div class="shop-icon">
          <img src="@/assets/img/cart-icon-2.png" />
          <span v-if="num" class="num">{{ num }}</span>
        </div>
        <div class="text">购物车</div>
      </div>
      <span v-if="k800 == 0" class="button" @click="addToCart">加入购物车</span>
      <span class="button button-1" @click="sureGo">立即购买</span>
    </div>
    <div class="occupied"></div>
    <van-dialog
      v-model="imgShow"
      title="微信扫码进入小程序购买"
      class="imgDialog"
    >
      <img
        :src="'data:image/jpg;base64,' + goodsInfo.productMallUrl"
        rel="external nofollow"
        class="base64Img"
      />
    </van-dialog>
  </div>
</template>
<script>
import EnvionmentVariables from "../../../../baseUrl";
import { setToken } from "utils/auth.js";
import Cookies from "js-cookie";
const wx = require("weixin-js-sdk");
export default {
  name: "todayActivity",
  components: {},
  data() {
    return {
      baseImg: EnvionmentVariables.IMAGE_HOST,
      images: ["@/assets/img/carousel.png", "@/assets/img/carousel.png"],
      goods: {
        // 默认商品 sku 缩略图
        picture: "https://img.yzcdn.cn/1.jpg",
      },
      currentIndex: 0,
      integerPrice: "",
      decimalsPrice: "",
      price: 192.9,
      modelList: [
        "智能加压入门级爆款U10L",
        "高清大屏热销款U12",
        "智能加压入门级爆款U10L",
        "高清大屏热销款U12",
        "【新款礼盒装】智能蓝牙U32",
        "高清大屏热销款U12",
      ],
      activeIndex: "",
      num: "",
      goodsInfo: {
        imagePath: [],
        name: "",
        sellerName: "",
        description: "",
      },
      windowWidth: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 10, // 每页请求的数量,
      k800: 0,
      imgShow: false,
    };
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff;");
    document.title = "商品详情";
  },
  created() {
    // this.windowWidth = document.documentElement.clientWidth //实时屏幕宽度
    this.id = this.$route.query.id;
    var token = this.$route.query.appToken;
    console.log("token");
    console.log(this.$route.query.appToken);
    if (this.$route.query.k800) {
      this.k800 = this.$route.query.k800;
    }
    if (token) {
      setToken(token);
    }

    this.getGoodDetails();
    this.getCartItemCount();
  },
  mounted() {
    console.log("choiceAddressId");
    Cookies.remove("choiceAddressId");
  },
  beforeRouteEnter(to, from, next) {
    console.log(this, "beforeRouteEnter"); // undefined
    console.log(to, "组件独享守卫beforeRouteEnter第一个参数");
    console.log(from, "组件独享守卫beforeRouteEnter第二个参数");
    console.log(next, "组件独享守卫beforeRouteEnter第三个参数");
    next((vm) => {
      // 因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      if (from.fullPath.indexOf("orderDetail") > -1) {
        vm.getCartItemCount();
      }
      console.log(vm); // 当前组件的实例
    });
  },
  methods: {
    // 获取购物车数量
    getCartItemCount() {
      var that = this;
      var param = {
        service: "appagg",
      };
      this.$api.GetCartItemCount(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.num = res.data.result;
          }
        }
      });
    },
    // 添加购物车
    addToCart() {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          goodsId: this.goodsInfo.id,
          quantity: 1,
        },
      };
      this.$api.AddToCart(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.$toast("加入成功");
            this.getCartItemCount();
          }
        }
      });
    },
    formatPrice(price) {
      var decimals = price.toString().split(".");
      this.integerPrice = decimals[0];
      if (decimals.length > 1) {
        this.decimalsPrice = decimals[1];
        if (decimals[1].length === 1) {
          this.decimalsPrice = this.decimalsPrice + "0";
        }
      } else {
        this.decimalsPrice = "00";
      }
    },
    accelerate(type) {
      if (type === 1) {
        // 减
        if (parseInt(this.num) > 1) {
          this.num = parseInt(this.num) - 1;
        }
      } else if (type === 2) {
        // 加
        this.num = parseInt(this.num) + 1;
      }
    },
    choose(index) {
      this.activeIndex = index;
    },
    onChange(index) {
      this.currentIndex = index;
    },
    buyNow() {},
    linkBuyCart() {
      this.$router.push({ path: "/shopCart", query: {} });
    },
    goBack() {
      this.$router.replace({ path: "/search", query: {} });
    },
    sureGo() {
      if (this.k800 == 1) {
        this.imgShow = true;
      } else {
        var singleGoods = [];
        var param = {
          sellerId: this.goodsInfo.sellerId,
          sellerLogo: this.goodsInfo.sellerLogo,
          sellerName: this.goodsInfo.sellerName,
        };
        var itemArr = [];
        var paramWrap = {
          goodsId: this.goodsInfo.id,
          goodsName: this.goodsInfo.name,
          marketPrice: this.goodsInfo.marketPrice,
          quantity: 1,
          salesPrice: this.goodsInfo.salesPrice,
          thumbnail: this.goodsInfo.thumbnail,
        };
        itemArr.push(paramWrap);
        param.items = itemArr;
        singleGoods.push(param);
        console.log("singleGoods");
        console.log(singleGoods);
        console.log(JSON.stringify(singleGoods));
        localStorage.setItem("chooseGoodsList", JSON.stringify(singleGoods));
        this.$router.push({ path: "/confirmOrder", query: { from: 1 } }); // 1. 从商品详情进来
      }
    },

    // 获取商品详情
    getGoodDetails() {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.id,
        },
      };
      this.$api.GetGoodsDetail(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            this.goodsInfo = res.data.result;
            this.formatPrice(this.goodsInfo.salesPrice);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.description {
  padding: 20px 0;
}
.description >>> p img {
  width: 100%;
  display: block;
  object-fit: contain;
  height: auto;
}
.description >>> p {
  font-size: 29px;
  /*font-weight: bold;*/
  color: #3e3e3e;
  margin: 0 20px;
  line-height: 44px;
}
.occupied {
  width: 100%;
  height: 136px;
}
.proDetailPic {
  width: 100%;
}
.num {
  width: 34px;
  height: 34px;
  line-height: 34px;
  font-size: 26px;
  color: #fff;
  background: red;
  border-radius: 50%;
  position: absolute;
  right: -14px;
  top: -4px;
}
.sure {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #ff3e29;
  border-radius: 12px;
  font-size: 32px;
  color: #fff;
  margin-top: 40px;
}
.plus {
  color: #3e3e3e;
  font-size: 60px;
}
.popTitle /deep/ .van-field__control {
  text-align: center;
}
.popTitle /deep/ .van-field {
  background: rgba(177, 177, 178, 0.2);
  border-radius: 8px;
  text-align: center;
  font-weight: bold;
  width: 100px;
  margin: 0 10px;
  padding: 0;
}
.mode.active {
  background: rgba(255, 62, 41, 0.1);
  border: 2px solid #ff3e29;
  border-radius: 12px;
}
.mode {
  background: rgba(177, 177, 178, 0.2);
  padding: 16px;
  border-radius: 12px;
  float: left;
  margin-right: 32px;
  margin-bottom: 20px;
  color: #3e3e3e;
  font-size: 24px;
  border: 2px solid transparent;
}
.popTitle {
  color: #3e3e3e;
  font-size: 28px;
  padding: 40px 0;
  font-weight: bold;
}
.wrap {
  align-self: flex-end;
}
.detail {
  color: #b1b1b2;
  font-size: 20px;
  margin-top: 30px;
}
.specil {
  height: 212px;
}
.proPic {
  width: 212px;
  height: 212px;
  margin-right: 24px;
  display: block;
}
/deep/ .van-popup--bottom {
  border-radius: 12px 12px 0px 0px;
  min-height: 300px;
  padding: 32px 32px 40px;
  box-sizing: border-box;
}

.shopName {
  width: 100%;
  height: 90px;
  line-height: 90px;
  padding: 0 29px;
  box-sizing: border-box;
  color: #3e3e3e;
  font-size: 24px;
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
  display: flex;
  align-items: center;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
}
.occupie {
  width: 100%;
  height: 32px;
  background: #f8f8f8;
}
.decimals {
  color: #ff3e29;
  font-size: 29px;
  font-weight: bold;
}
.value {
  color: #ff3e29;
  font-size: 60px;
}
.unit {
  color: #ff3e29;
  font-size: 29px;
}
.subscript {
  padding: 6px 17px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 24px;
  position: absolute;
  right: 64px;
  bottom: 38px;
  color: #fff;
  font-size: 24px;
  z-index: 100;
}
.carousel {
  /*height: 532px;*/
  position: relative;
  border-bottom: 2px solid rgba(208, 214, 230, 0.31);
}
/*.van-swipe {*/
/*  height: 532px;*/
/*}*/
.mask_layer {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  background: #000;
  opacity: 0.5;
  overflow: hidden;
  top: 0;
  left: 0;
}
.orgPrice {
  text-decoration: line-through;
  color: #999;
}
.proPrice {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  color: #3e3e3e;
  margin-bottom: 24px;
  align-items: baseline;
}
.allFlexCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padBox {
  padding: 24px 29px;
}
.proName {
  font-size: 29px;
  font-weight: bold;
  color: #3e3e3e;
  line-height: 44px;
}
.imgPic {
  width: 100%;
  /*height: 532px;*/
}
.f-box {
  position: fixed;
  width: 100%;
  height: 128px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  z-index: 9;
  cursor: pointer;
}
.shop-btn {
  flex: 1;
  text-align: center;
  padding-top: 15px;
}
.shop-btn .shop-icon {
  position: relative;
  width: 48px;
  height: 48px;
  margin: 0 auto;
}
.shop-btn .shop-icon img {
  width: 100%;
  height: 100%;
  display: block;
}
.shop-btn .text {
  font-size: 20px;
  color: #3e3e3e;
  padding-top: 10px;
}
.f-box .button {
  height: 64px;
  line-height: 64px;
  width: 262px;
  color: #fff;
  margin: 0;
  font-size: 29px;
  display: block;
  text-align: center;
  border-radius: 8px;
  margin-top: 32px;
}
.f-box .button {
  width: 262px;
  background-color: #ff3e29;
}
.f-box .button-1 {
  background-color: #ffaf46;
  margin-left: 30px;
  margin-right: 30px;
}
/deep/ .van-button {
  background: #fd6501;
  border: 1px solid #fd6501;
  width: 90%;
  margin: 0 auto;
  height: 76px;
  line-height: 76px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
/deep/ .van-swipe-item {
  height: auto;
}
/deep/ .van-swipe__track {
  height: auto;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.base64Img {
  width: 100%;
}
</style>
<style scoped lang="less">
.imgDialog {
  /deep/.van-button {
    color: #ffffff;
    background: #357dfa;
    border: 0.013333rem solid #357dfa;
  }
}
.description {
  p img {
    width: 100%;
    display: block;
    object-fit: contain;
    height: auto;
  }
}
</style>
